import { keyframes } from 'styled-components'

const fadeOut = keyframes`
  0% { opacity: 1; visibility: visible; }
  50% { opacity: 0.5; }
  100% { opacity: 0; visibility: hidden;}
`
const fadeOut2 = keyframes`
  0% { opacity: 0; visibility: hidden; }
  20% { opacity: 1; visibility: visible; }
  80% { opacity: 1; }
  100% { opacity: 0; visibility: hidden;}
`

export { fadeOut, fadeOut2 }
